export enum ReverseSide {
  'buy' = 'sell',
  'sell' = 'buy',
  'long' = 'short',
  'short' = 'long',
}

export enum AlgoOrderType {
  conditional = 'conditional',
  oco = 'oco',
  trigger = 'trigger',
  'move_order_stop' = 'move_order_stop',
}

/**
 * - tp 止盈订单种类;
 * - sl 止损订单种类;
 * - adl ADL订单种类;
 * - partial_liquidation 减仓订单种类;
 * - unknown 无
 */
export enum TypesCategory {
  unknown = 'unknown',
  liquidation = 'liquidation',
  partial_liquidation = 'partial_liquidation',
  adl = 'adl',
  tp = 'tp',
  sl = 'sl',
}

export enum botState {
  starting = 'starting',
  running = 'running',
  stopping = 'stopping',
  stopped = 'stopped',
}

export enum BadgeBot {
  starting = 'primary',
  running = 'success',
  stopping = 'warning',
  stopped = 'danger',
}

export enum SignalBotState {
  starting = 'starting',
  running = 'running',
  stopping = 'stopping',
  stopped = 'stopped',
}

export enum AlgoOrderState {
  signal_bot = 'signal_bot',
  move_order_stop = 'move_order_stop',
  twap = 'twap',
}

export enum TwapState {
  pending = 'pending',
  stopped = 'stopped',
  partially_stopped = 'partially_stopped',
  partially_activated = 'partially_activated',
  activated = 'activated',
}

export enum BadgeTwapState {
  pending = 'warning',
  stopped = 'info',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  partially_stopped = 'info',
  partially_activated = 'success',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  activated = 'success',
}

export enum CancelSource {
  not_canceled = 'not_canceled',
  user_canceled = 'user_canceled',
  cancel_by_asset_not_enough = 'cancel_by_asset_not_enough',
  cancel_by_position_reached_current_leverage_limit = 'cancel_by_position_reached_current_leverage_limit',
  cancel_by_reduce_only_quantity = 'cancel_by_reduce_only_quantity',
}

export enum TwapOrderDetailStatus {
  new = 'new',
  filled = 'filled',
  canceled = 'canceled',
  partially_canceled = 'partially_canceled',
  fail = 'fail',
}

/**
 * - partially_closed 部分平仓
 * - closed 全部平仓
 * - liquidated 强平
 * - partially_liquidated 强减
 * - adl 自动减仓
 */
export enum PositionTypeState {
  partially_closed = 'partially_closed',
  closed = 'closed',
  liquidated = 'liquidated',
  partially_liquidated = 'partially_liquidated',
  adl = 'adl',
}
